

import { DrawingService } from "../../Services/DrawingService";
import { IndicatorDrawers } from "../IndicatorDrawers";
import { WaveDirection, WaveType } from "../WaveComputer";
import { Averages } from "../AveragesComputer";
import { LineWave, SerieColor } from "../LineSerie";
import { Configs } from "../Configs";
import { LineData, Time } from "lightweight-charts";
import { SeriesMarker, SeriesMarkerPosition, SeriesMarkerShape } from "../lcharts/src/model/series-markers";

export class SmaDiffOscillator extends IndicatorDrawers {
  
  constructor(private _drawingService:DrawingService) {
    super(_drawingService);
   };

  public period:number = 8
  public drawAction(canShow: boolean) 
  {

    if (!this.markerSerie) 
    {
     this.markerSerie = this.chart.addLineSeries(LineWave.transparentSerieOptions(), 0);
    }

    if(canShow==false)
    {
      this.targetLineSerie.setData([]);
      this.additionalLineSerie.setData([]);
      this.markerSerie.setData([]);
      return;
    }
    else
    {


      let down: LineData[] = [];
      let up: LineData[] = [];

      var overlayedData = this.bindedWaveComputer.pernamentSerie;



      this.wavesAsSource = this.bindedWaveComputer.getAllWaves();

      if(this._drawingService.settingsService.diffValue==63)
      {
        this.wavesAsSource = this.bindedOverlayWaveComputer.getAllWaves();
      }
        //    this.wavesAsSource = this.bindedOverlayWaveComputer.getAllWaves();
            
            let waves = this.wavesAsSource;

            let filteredDown = waves.filter(v => {
              if (!v) return false;
              return v.direction == WaveDirection.DOWN && v.type == WaveType.PERNAMENT;
              
            })

            let filteredUp = waves.filter(v => {
              if (!v) return false;
              return v.direction == WaveDirection.UP && v.type == WaveType.PERNAMENT;
              
            })

            var serie:LineData[] = [];
            filteredDown.forEach(element => {
                let val = element.data[1].value - element.data[0].value;
                down.push({ time: element.data[0].time, value: val });
            })

            filteredUp.forEach(element => {
                let val = element.data[1].value - element.data[0].value;
                up.push({ time: element.data[1].time, value: val });
            })

    















      let shorterListLastTime = down.length > up.length ? up[up.length - 1].time : down[down.length - 1].time;

      if (down.length > up.length) {
        down = trimListToMatchTime(down, shorterListLastTime);
      } else if (up.length > down.length) {
          up = trimListToMatchTime(up, shorterListLastTime);
      }


      if (down.length > up.length) {
        down=down.slice(1)
      }

      if (up.length > down.length) {
        up=up.slice(1)
      }
       var avg35:LineData[] = [];
       var avg33:LineData[] = [];
       var avgSum:LineData[] = [];
       var avgAll:LineData[] = [];
       var avgFD:LineData[] = [];
       var avgHD:LineData[] = [];
       var avgThirdLine:LineData[] = [];
       var avgHDRender:LineData[] = [];
       var avgThirdLineRender:LineData[] = [];
      
       avg35 = Averages.computeSma(down, this.period);//C
       avg33 = Averages.computeSma(up, this.period);//D

       //console.log("down,up",down,up);
       for (let i = 0; i < avg35.length; i++) {
        try{
          const sumValue = avg35[i].value + avg33[i].value;
          const avgValue = (avg33[i].value - avg35[i].value)*0.5;//E

         // const avgThirdLineValue = (avgValue-34.5)*2;
          const avgF = (avgValue-Number(this._drawingService.settingsService.diffValue))*2;//F

          const avgH = sumValue+avgF;//+ this._drawingService.smaBase;

          avgSum.push({ time: avg35[i].time, value: sumValue });
          avgAll.push({ time: avg35[i].time, value: avgValue });
          avgFD.push({ time: avg35[i].time, value: avgF });
          avgHD.push({ time: avg35[i].time, value: sumValue });
          avgThirdLine.push({ time: avg35[i].time, value: avgF });

        }
        catch(ex)
        {
          //console.log(ex)
        }
      }


      this._drawingService.smaBaseSerie;

      avgHDRender = avgHD.map((l)=>{
        var base = this._drawingService.smaBaseSerie.get(l.time);
        if(base)
        {
          l.value = l.value+base.value;
        }
        else
        {
          l.value = l.value+this._drawingService.smaBase;
        }
        return l;
      })

      avgThirdLineRender = avgThirdLine.map((l)=>{
        var base = this._drawingService.smaBaseSerie.get(l.time);
        if(base)
        {
          l.value = l.value+this._drawingService.smaBase;
        }
        else
        {
          l.value = l.value+this._drawingService.smaBase;
        }
        return l;
      })


        
         this.markers = [];




         var minimmax = findExtremaBetweenZeroCrossings(avgHD);
    var underline  = true;


    
var limit = 0;
      for (let i = 0; i < minimmax.maxima.length; i++) {
        let v = minimmax.maxima[i];
        let index = i;
     //   if (i > 0) {
   
          let diff = minimmax.maxima[index].value;// - avgHD[index - 1].value;
          if(Math.abs(diff)>limit){
          var marker: SeriesMarker<Time> = {
            time: v.time,
            position: 'inBarOffset' as SeriesMarkerPosition,
            color: (diff > 0) ? SerieColor.UP : SerieColor.DOWN,
            textColor: (diff > 0) ? SerieColor.UP : SerieColor.DOWN,
            // color: (diff > 0) ? SerieColor.UP : SerieColor.DOWN,
            // textColor: (diff > 0) ? SerieColor.UP : SerieColor.DOWN,
            shape: 'textMarker' as SeriesMarkerShape,
            id: "x" + v.time.toString(),
            text: `${Math.round(Math.abs(diff)).toFixed(0)}`,
            size: 2,
            font: (underline) ? "bold 20px Arial underline" : "bold 20px Arial",
            positionOffset: { x: Configs.waveMarkerLocationOffset().x, y: (diff > 0) ? Configs.waveMarkerLocationOffset().yUp : Configs.waveMarkerLocationOffset().yDown, secondMarkerOffset: 18 },
            isLast: (avgHD.length - 1) ? true : false,
            lastType: (underline) ? "bull" : "bear"
          }
          this.markers.push(marker);
          }
      //  }
      }




      for (let i = 0; i < minimmax.minima.length; i++) {
        let v = minimmax.minima[i];
        let index = i;
     //   if (i > 0) {
          let diff = minimmax.minima[index].value;// - avgHD[index - 1].value;
          if(Math.abs(diff)>limit){
          var marker: SeriesMarker<Time> = {
            time: v.time,
            position: 'inBarOffset' as SeriesMarkerPosition,
            color: (diff > 0) ? SerieColor.UP : SerieColor.DOWN,
            textColor: (diff > 0) ? SerieColor.UP : SerieColor.DOWN,
            // color: (diff > 0) ? SerieColor.UP : SerieColor.DOWN,
            // textColor: (diff > 0) ? SerieColor.UP : SerieColor.DOWN,
            shape: 'textMarker' as SeriesMarkerShape,
            id: "x" + v.time.toString(),
            text: `${Math.round(Math.abs(diff)).toFixed(0)}`,
            size: 2,
            font: (underline) ? "bold 20px Arial underline" : "bold 20px Arial",
            positionOffset: { x: Configs.waveMarkerLocationOffset().x, y: (diff > 0) ? Configs.waveMarkerLocationOffset().yUp : Configs.waveMarkerLocationOffset().yDown, secondMarkerOffset: 18 },
            isLast: (avgHD.length - 1) ? true : false,
            lastType: (underline) ? "bull" : "bear"
          }
          this.markers.push(marker);
        }
      //  }
      }


      avgHD
          var v = avgHD[avgHD.length-1];
        let diff = v.value;
        var marker: SeriesMarker<Time> = {
          time: v.time,
          position: 'inBarOffset' as SeriesMarkerPosition,
          color: (diff > 0) ? SerieColor.YELLOW : SerieColor.YELLOW,
          textColor: (diff > 0) ? SerieColor.YELLOW : SerieColor.YELLOW,
          // color: (diff > 0) ? SerieColor.UP : SerieColor.DOWN,
          // textColor: (diff > 0) ? SerieColor.UP : SerieColor.DOWN,
          shape: 'textMarker' as SeriesMarkerShape,
          id: "x" + v.time.toString(),
          text: `${Math.round(Math.abs(diff)).toFixed(0)}`,
          size: 2,
          font: (underline) ? "bold 20px Arial underline" : "bold 20px Arial",
          positionOffset: { x: Configs.waveMarkerLocationOffset().x, y: (diff > 0) ? Configs.waveMarkerLocationOffset().yUp : Configs.waveMarkerLocationOffset().yDown, secondMarkerOffset: 18 },
          isLast: (avgHD.length - 1) ? true : false,
          lastType: (underline) ? "bull" : "bear"
        }
        this.markers.push(marker);

      this.markerSerie.setData(avgHDRender);
      this.markerSerie.setMarkers(this.markers);
 
      //const avgH = sumValue+avgF+ this._drawingService.smaBase;
      // var serie:LineData[] = [];
      // waves.forEach(element => {
      //   serie.push({time:element.data[0].time, value:-10+element.data[0].value})
      // })

    
      //console.log("avg35,avg33",avg35,avg33);
      //console.log("G,avgAll",avgSum,avgAll);
      //console.log("avgFD",avgFD);
      //console.log("avgH",avgHD);



      

      //console.log("minimmax",minimmax);








      this.targetLineSerie.setData(avgHDRender);
   this.additionalLineSerie.setData(avgThirdLineRender);

    }





    

    function trimListToMatchTime(list: LineData[], time: Time): LineData[] {
      let index = list.findIndex(item => item.time === time);
      if (index !== -1) {
          return list.slice(0, index + 1);
      }
      return list;
  }












  function findExtremaBetweenZeroCrossings(list: LineData[]): { maxima: LineData[], minima: LineData[], isOpen: boolean } {
    let maxima: LineData[] = [];
    let minima: LineData[] = [];
    let currentExtremum = list[0];
    let previousSign = Math.sign(list[0].value);
    let isOpen = false;

    for (let i = 1; i < list.length; i++) {
        let currentSign = Math.sign(list[i].value);
        if (currentSign !== previousSign && previousSign !== 0) {
            if (previousSign > 0) {
                maxima.push(currentExtremum);
            } else {
                minima.push(currentExtremum);
            }
            currentExtremum = list[i];
        } else {
            if ((previousSign >= 0 && list[i].value > currentExtremum.value) ||
                (previousSign < 0 && list[i].value < currentExtremum.value)) {
                currentExtremum = list[i];
            }
        }
        previousSign = currentSign;
    }

    // Sprawdź, czy ostatni segment jest otwarty
    isOpen = (previousSign > 0 && currentExtremum.value > 0) || (previousSign < 0 && currentExtremum.value < 0);

    return { maxima, minima, isOpen };
}
  }

}
